import React from "react";
import { withSearch } from "@elastic/react-search-ui";
import i18n from '../i18n';
import { withTranslation, Trans } from 'react-i18next';

function ClearFilters({filters,clearFilters,clearFilter,addFilter,searchMode,t}) {

  const clear = () => {
    if(searchMode != "id") {
      clearFilter();
      addFilter("not_discontinued", "true", "any");
    } else {
      clearFilter();
    }
  }

  
  return (
    <div className="clear-filter-wrapper">
      <button className="btn clear-filter w-100" onClick={() => clear()}>
        {t("Clear all filter")}
        <i className="close-icon">
          <img src="/img/svgs/close.svg" className="normal-img" alt="close-icon" />
          <img src="/img/svgs/close-h.svg" className="hover-img" alt="close-icon" />
        </i>
      </button>
    </div>
  );
}

export default withSearch(({ filters, clearFilters, addFilter,searchMode }) => ({
  filters,
  clearFilters,
  addFilter,
  searchMode
}))(withTranslation()(ClearFilters));